import fEvents from '../../js/events';

export default class PhoneInput extends HTMLElement {

    iti: any;
    errorMap: string[];

    constructor() {
        super();
        this.errorMap = ['Invalid number', 'Invalid country code', 'Too short', 'Too long', 'Invalid number', 'Invalid number'];
        const shadowRoot = this.attachShadow({ mode: 'open' });
        shadowRoot.innerHTML = this.render();
        const input = shadowRoot.querySelector('input#phone') as HTMLInputElement;

        const iti = (window as any).intlTelInput(input, {
            loadUtilsOnInit: 'https://cdn.jsdelivr.net/npm/intl-tel-input@24.6.0/build/js/utils.js',
            initialCountry: 'NL',
            separateDialCode: false,
            containerClass: 'intl-tel-input',
        });
        this.iti = iti;
        fEvents.attachEvent('input#phone', 'input', () => {
            fEvents.dispatch(this, 'change', { phoneNumber: this.phoneNumber });
        }, this.shadowRoot);
    }

    attributeChangedCallback(name: string, oldValue: string, newValue: string): void {
        if (oldValue === newValue) {
            return;
        }

        if (name === 'aria-readonly') {
            const input = this.shadowRoot.querySelector('input#phone') as HTMLInputElement;
            // disable input if readonly
            input.readOnly = newValue === 'true';
        } else if (name === 'data-value') {
            const input = this.shadowRoot.querySelector('input#phone') as HTMLInputElement;
            input.value = newValue;
        }
    }

    static get observedAttributes() {
        return ['aria-readonly', 'data-value'];
    }

    public get phoneNumber(): string | null {
        const input = this.shadowRoot.querySelector('.input-phone') as HTMLInputElement;
        const errorSpan = this.shadowRoot.querySelector('.error') as HTMLSpanElement;
        if (this.iti.isValidNumber()) {
            errorSpan.style.display = 'none';
            input.classList.remove('input-error');
            return this.iti.getNumber();
        } else {
            const error = this.iti.getValidationError();
            const phoneError = error ? this.errorMap[error] : 'Invalid number';
            errorSpan.style.display = 'block';
            errorSpan.innerText = phoneError;
            input.classList.add('input-error');
            return null;
        }
    }

    render = (): string => `
       <link rel="stylesheet" href="https://cdn.jsdelivr.net/npm/intl-tel-input@24.6.0/build/css/intlTelInput.css">
        <link rel="stylesheet" href="/styles/index.css">
        <style>
            .container { position: relative; }
            input#phone { width: 100%; height: 50px; border: 1px solid #CDD5E4; font-size: inherit; box-shadow: 0 8px 35px 0 rgb(0 0 0 / 10%); }
            .intl-tel-input { width: 100%; }
            input[readonly] { background-color: #f9f9f9; cursor: not-allowed; }
            .error { position: absolute; bottom: 0px; left: 50px; font-size: 12px; color: red; }
            .input-error { border: 1px solid red !important; }
        </style>

        <div class="container">
            <input id="phone" class="input-phone" name="phone number"  />
            <span class="error"></span>
        </div>

    `;
}

customElements.define('phone-input', PhoneInput);
